import React, { useState, useEffect } from "react";
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment, InputBase } from '@mui/material';
import { pincodeMaxLength, typeNumberValid } from '../commonValidations';
import { BLOCK_LIST, REVENUE_BLOCK_DEFAULT_VALUE, REVENUE_CIRCLE } from '../constants';
import { loaderService } from '../custom-loader/loader-service';
import apiClient from 'axios';
import { ADD_GROWER, GET_ADDRESS_BY_PINCODE, authKey, GET_ALL_BLOCKLIST_AND_REVENUECIRCLE } from '../../common/URLs';
import "./commonPincode.css";
import { Container, Card, CardContent, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { useTranslation } from "react-i18next";
import { handleNumberFieldFocus } from "../commonFunction";
import { Badge } from "react-bootstrap";
import BadgeComponent from "../badge";

export const CommonPincodeMUI = (props) => {
    const { t, i18n } = useTranslation();
    const [pincodeDetails, setPincodeDetails] = useState();
    const [revenueCircleBlockListLabel, setRevenueCircleBlockListLabel] = useState(t('preReg.revenueBlock'));
    const [revenueCircleCircleBlockNameList, setRevenueCircleCircleBlockNameList] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [details, setDetails] = useState({
        pincode: props.pincode ? props.pincode : '',
        pincodeState: props.state ? props.state : '',
        pincodeDistrict: props.district ? props.district : '',
        pincodeSubDivision: props.subDivision ? props.subDivision : '',
        selectedBlockName: props.blockName ? props.blockName : '',
        selectedRevenueCircle: props.revenueCircle ? props.revenueCircle : '',
    })
    // const [errorMessage, setErrorMessage] = useState({
    //     pincodeError: '',
    //     searchError: '',
    //     blockNameError: '',
    // })
    const [searchPincode, setSearchPincode] = useState(false);
    useEffect(() => {
        setPropsData();
    }, [props.pincode])
    const setPropsData = () => {
        setDetails({
            ...details,
            pincode: props.pincode ? props.pincode : '',
            pincodeState: props.state ? props.state : '',
            pincodeDistrict: props.district ? props.district : '',
            selectedBlockName: props.blockName ? props.blockName : '',
            pincodeSubDivision: props.subDivision ? props.subDivision : '',
            selectedRevenueCircle: props.revenueCircle ? props.revenueCircle : '',
        })
    }

    const getPincodeAddressDetails = (pincodeSearch,pincode) => {
        setSearchPincode(pincodeSearch);
        loaderService.showLoader();
        apiClient
            .post(GET_ADDRESS_BY_PINCODE,
                {
                    "pincode": pincode ? pincode : details.pincode,
                },
                {
                    headers: {
                        AuthKey: authKey,
                    },
                }).then((response) => {
                    setPincodeDetails(response.data);
                    const stateList = [];
                    response.data.addresses.map((item) => {
                        var findItem = stateList.find((x) => x === item.state);
                        if (!findItem) stateList.push(item.state);
                    });
                    setStateList(stateList);
                    if (pincodeSearch) {
                        setDetails({
                            ...details,
                            pincode: response.data.addresses[0]?.pincode,
                            //pincodeDistrict: response.data.addresses[0]?.district,
                            pincodeState: response.data.addresses[0]?.state,
                            //pincodeSubDivision: response.data.addresses[0]?.subDivision
                        })
                    }
                    else {
                        const districtList = [];
                        response.data.addresses.map((item) => {
                            if (item.state == details.pincodeState) {
                                var findItem = districtList.find((x) => x === item.district);
                                if (!findItem) districtList.push(item.district);
                            }
                        });
                        setDistrictList(districtList);
                    }

                    if (response.data.addresses == null || response.data.addresses.length == 0) {
                        props.onHandleCallback({ ...details, pincode: response.data.addresses[0]?.pincode, selectedRevenueCircle: "", selectedBlockName: "", pincodeState: "", pincodeDistrict: "" });
                    }
                    else {
                        props.setErrorMessage({ ...props.errorMessage, pincodeError: "" });
                    }
                    loaderService.hideLoader();
                }).catch(function (error) {
                    console.log(error);
                    loaderService.hideLoader();
                });
    }
    useEffect(() => {
        if (details.pincodeDistrict) {
            getRevenuCircleAndBlockList(details.pincodeDistrict, details.pincodeState);
        }
    }, [details.pincodeDistrict])
    useEffect(() => {
        if (details.pincodeState) {
            if (!searchPincode) {
                getPincodeAddressDetails(false, details.pincode);
            }
            else {
                const districtList = [];
                pincodeDetails.addresses.map((item) => {
                    if (item.state == details.pincodeState) {
                        var findItem = districtList.find((x) => x === item.district);
                        if (!findItem) districtList.push(item.district);
                    }
                });
                setDistrictList(districtList);
                if (searchPincode) {
                    setDetails({
                        ...details,
                        pincodeDistrict: districtList[0],
                    })

                }
            }
        }
        else {
            setDistrictList([]);
            setRevenueCircleCircleBlockNameList([]);
        }
    }, [details.pincodeState])
    const getRevenuCircleAndBlockList = (pincodeDistrict, pincodeState) => {
        loaderService.showLoader();
        apiClient.post(GET_ALL_BLOCKLIST_AND_REVENUECIRCLE,
            {
                "district": pincodeDistrict,
            },
            {
                headers: {
                    AuthKey: authKey,
                },
            }
        )
            .then((response) => {
                if (pincodeState === "ASSAM") {
                    setRevenueCircleBlockListLabel(t('preReg.revenueCircle'));
                    setRevenueCircleCircleBlockNameList(response.data.revenueCircleAndBlockList.revenueCircleLists);
                    if (response.data.revenueCircleAndBlockList.revenueCircleLists.length > 0) {
                        var selectedRevCircle = details.selectedRevenueCircle;
                        if (searchPincode) {
                            selectedRevCircle = response.data.revenueCircleAndBlockList.revenueCircleLists[0];
                            setSearchPincode(false);
                        }
                        setDetails({ ...details, selectedRevenueCircle: selectedRevCircle, selectedBlockName: "" });
                        props.onHandleCallback({ ...details, pincode: details.pincode, selectedRevenueCircle: selectedRevCircle, selectedBlockName: "", pincodeState: pincodeState, pincodeDistrict: pincodeDistrict });
                    } else {
                        setDetails({ ...details, selectedRevenueCircle: '', selectedBlockName: '' });
                        props.onHandleCallback({ ...details, pincode: details.pincode, selectedRevenueCircle: '', selectedBlockName: '', pincodeState: pincodeState, pincodeDistrict: pincodeDistrict });
                    }

                } else {
                    setRevenueCircleBlockListLabel(t('preReg.blockOffice'));
                    setRevenueCircleCircleBlockNameList(response.data.revenueCircleAndBlockList.blockLists);
                    if (response.data.revenueCircleAndBlockList.blockLists.length > 0) {
                        var selectedBlock = details.selectedBlockName;
                        if (searchPincode) {
                            selectedBlock = response.data.revenueCircleAndBlockList.blockLists[0];
                            setSearchPincode(false);
                        }
                        setDetails({ ...details, selectedBlockName: selectedBlock, selectedRevenueCircle: "" });
                        props.onHandleCallback({ ...details, pincode: details.pincode, selectedBlockName: selectedBlock, selectedRevenueCircle: "", pincodeState: pincodeState, pincodeDistrict: pincodeDistrict });
                    } else {
                        setDetails({ ...details, selectedBlockName: '', selectedRevenueCircle: '' });
                        props.onHandleCallback({ ...details, pincode: details.pincode, selectedBlockName: '', selectedRevenueCircle: '', pincodeState: pincodeState, pincodeDistrict: pincodeDistrict });
                    }

                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }
    const handleChange = (e) => {
        e.preventDefault();
        if (e.target.name === "pincode") {
            const limit = 6;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length < 6) {
                props.setErrorMessage({ ...props.errorMessage, pincodeError: "Please enter 6 digit pincode" });
                if (details.pincodeDistrict !== "" || details.pincodeState !== "") {
                    setDetails({
                        ...details,
                        pincode: e.target.value.slice(0, limit),
                        pincodeState: '',
                        pincodeDistrict: '',
                        selectedBlockName: '',
                        pincodeSubDivision: '',
                        selectedRevenueCircle: ''
                    });
                    setRevenueCircleCircleBlockNameList([]);
                    setDistrictList([]);
                    setStateList([]);
                    props.onHandleCallback({ ...details, pincode: e.target.value.slice(0, limit), selectedRevenueCircle: "", selectedBlockName: "", pincodeState: "", pincodeDistrict: "" });
                }
            }
            else {
                props.setErrorMessage({ ...props.errorMessage, pincodeError: "" });
                getPincodeAddressDetails(true,e.target.value.slice(0, limit));
            }
        }
        if (e.target.name === "blockName") {
            setDetails({ ...details, [e.target.name]: e.target.value })
            // if ((e.target.value).length == 0) {
            //     setErrorMessage({ ...errorMessage, blockNameError: "Please enter block office" });
            // }
            // else setErrorMessage({ ...errorMessage, blockNameError: "" });
        }
    }
    const handleDistrictChange = (e) => {
        e.preventDefault();
        setSearchPincode(true);
        setDetails({ ...details, pincodeDistrict: e.target.value });
    }
    const handleStateChange = (e) => {
        e.preventDefault();
        setSearchPincode(true);
        setDetails({ ...details, pincodeState: e.target.value });
    }
    return (
        <>
            <Grid item xs={4} lg={props.fullWidth ? 2 : 4}>
                <TextField fullWidth
                    required={props?.notRequired ? false : true}
                    error={props.pincodeError}
                    helperText={props.pincodeError}
                    label={t('preReg.pincode')}
                    disabled={props.isDisabled}
                    onChange={(e) => handleChange(e)}
                    type="number"
                    onFocus={handleNumberFieldFocus}
                    onKeyDown={(evt) => typeNumberValid(evt)}
                    value={details.pincode || ''}
                    name="pincode"
                />
               <BadgeComponent currentLength={details?.pincode?.length} maxLength={pincodeMaxLength}/>
                            
            </Grid>
            <Grid item xs={8} lg={props.fullWidth ? 3 : 8}>
                {/*<TextField fullWidth*/}
                {/*    type="text"*/}
                {/*    label="State"*/}
                {/*    disabled*/}
                {/*    value={details.pincodeState} />  */}
                <FormControl fullWidth required={props?.notRequired ? false : true}>
                    <InputLabel>{t('preReg.state')}</InputLabel>
                    <Select label={t('preReg.state')}
                        disabled={props.isDisabled}
                        name="State"
                        value={props.state || ''}
                        onChange={(e) => handleStateChange(e)}>
                        {stateList?.length > 0 ? stateList?.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>) : <MenuItem>No data to display</MenuItem>}
                    </Select>
                </FormControl>      
            </Grid>
            <Grid item xs={12} lg={props.fullWidth ? 3 : 12}>
                <FormControl fullWidth required={props?.notRequired ? false : true}>
                    <InputLabel>{t('preReg.district')}</InputLabel>
                    <Select label={t('preReg.district')}
                        disabled={props.isDisabled}
                        name="District"
                        value={props.district || ''}
                        onChange={(e) => handleDistrictChange(e)}>
                        {districtList?.length > 0 ? districtList?.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>) : <MenuItem>No data to display</MenuItem>}
                    </Select>
                </FormControl>         
              
            </Grid>
            <Grid item xs={12} lg={props.fullWidth ? 4 : 12}>
                {/*<TextField fullWidth*/}
                {/*    label="District"*/}
                {/*    disabled*/}
                {/*    type="text"*/}
                {/*    value={details.pincodeDistrict} />*/}
                <FormControl fullWidth required={props?.notRequired || props?.revenueNotRequired ? false : true} error={props.blockNameError}>
                    <InputLabel>{revenueCircleBlockListLabel}</InputLabel>
                    <Select label={revenueCircleBlockListLabel}
                        disabled={props.isDisabled}
                        name={revenueCircleBlockListLabel}
                        value={revenueCircleBlockListLabel == t('preReg.revenueCircle') ? (props.revenueCircle)?.toUpperCase() || '' : props.blockName || ''}
                        onChange={(e) => props.handleChangeSelect(e, revenueCircleBlockListLabel)}>
                        {revenueCircleCircleBlockNameList?.length > 0 ? revenueCircleCircleBlockNameList?.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>) : <MenuItem value="">No data to display</MenuItem>}
                    </Select>
                    <FormHelperText sx={{ color: 'red' }}>{props.blockNameError}</FormHelperText>
                </FormControl>
                
            </Grid>
        </>
    )
}